<template>
  <v-row dense>
    <v-col>
      <v-row dense>
        <v-col>
          <v-select
            label="נושא"
            v-model="card.subject"
            :items="subjects"
            dense
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row v-if="card.subject == 'SIMPLE_PERFORMANCE'" dense>
        <v-col>
          <v-select
            label="תקופת ברירת מחדל"
            v-model="defaultYears"
            :items="yearOptions"
            dense
            outlined
            hide-details
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense
        ><v-col>
          <complex-string-editor
            v-model="card.subTitle"
            @start-edit="startEditComplexString(card, 'subTitle')"
            label="כותרת משנית"
          ></complex-string-editor>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import ComplexStringEditor from "../ComplexStringEditor.vue";
export default {
  props: {
    card: { type: Object, required: true }
  },
  components: { ComplexStringEditor },
  computed: {
    defaultYears: {
      get() {
        return this.card.defaultYears || 5;
      },
      set(value) {
        this.$set(this.card, "defaultYears", value);
      }
    }
  },
  data() {
    return {
      subjects: [
        { value: "PRISHA_COST_OF_LIVING", text: "תחזית איכות חיים בפרישה" },
        { value: "PERFORMANCE", text: "ביצועי קופות" },
        { value: "SIMPLE_PERFORMANCE", text: "ביצועי תיק (מבט מהיר)" },
        { value: "TSUA", text: "תשואות" },
        { value: "DEATH_COVERAGE", text: "כיסוי ביטוחי למקרה מוות" },
        { value: "DEMI_NIHUL", text: "דמי ניהול" },
        { value: "OPTIMIZATION", text: "אופטימיזציה" }
      ],
      yearOptions: [
        { value: 1, text: "שנה" },
        { value: 2, text: "2 שנים" },
        { value: 3, text: "3 שנים" },
        { value: 4, text: "4 שנים" },
        { value: 5, text: "5 שנים" }
      ]
    };
  },
  methods: {
    startEditComplexString(item, field) {
      this.$emit("edit-complex-string", item, field);
    }
  }
};
</script>

<style></style>
